import Notice from '../../../components/base/notice';
import React from 'react';

const KitchenStatsPageTen = () => {
  return <Notice />;
};

export default KitchenStatsPageTen;
